<template>
  <b-modal
    :visible="value"
    :title="title"
    size="sm"
    hide-footer
    centered
    @change="modalChangeEvent"
  >

    <div class="mt-4 text-right">
      <BfButton
        variant="secondary"
        class="mr-3"
        @click="modalChangeEvent(false)"
      >
        Cancelar
      </BfButton>
      <BfButton variant="red" @click="confirmDeletion">
        Si
      </BfButton>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'DeleteWarningModal',

  props: {
    title: {
      type: String,
    },

    value: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    modalChangeEvent(visible) {
      this.$emit('input', visible);
    },

    confirmDeletion() {
      this.$emit('confirm-deletion');
    },
  },
};
</script>
